<template>
  <b-sidebar
    id="sidebar-monitoring-report-files"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Files') }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>

      <div class="p-2 pb-0">
        <b-list-group>
          <b-list-group-item
            v-for="file in files"
            :key="file.file"
          >
            <a
              :href="file.file"
              target="_blank"
            >{{ file.name }}</a>
          </b-list-group-item>
        </b-list-group>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BListGroup, BListGroupItem,
} from 'bootstrap-vue'

export default {
  name: 'MonitoringReportFiles',
  components: {
    BSidebar,
    BListGroup,
    BListGroupItem,
  },
  computed: {
    files() {
      return this.$store.state.monitoringReport.files
    },
  },
  methods: {
    clear(hide) {
      this.freshData(hide)
    },
    freshData(hide) {
      this.$store.commit('monitoringReport/GET', null)
      this.$store.commit(`${this.MODULE_NAME}/FILES`, [])
      hide()
    },
  },
}
</script>
<style scoped>

</style>
